import script from "./SmInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmInput.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__